<template>
    <div>
        <GoogleMapLoader
            :mapConfig="mapConfig"
            :apiKey="mapKey">
            <template slot-scope="{google, map}" ref="map">
                <GoogleMapMarker
                    :firebaseDriver="firebaseDriver"
                    :google="google"
                    :map="map"
                />
            </template>
        </GoogleMapLoader>
    </div>
</template>
<script>
import GoogleMapLoader from '../map/GoogleMapLoader'
import GoogleMapMarker from '../map/DriverMarker'
import { mapSettings } from '../../../constants/mapSettings'
import config from '../../../../environment.json'
export default {
  name: 'DriverMap',
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },
  props: {
    firebaseDriver: {
      typeObject: Object,
      required: true,
    },
  },
  computed: {
    mapConfig () {
      return {
        ...mapSettings,
        center: this.mapCenter,
      }
    },
    mapCenter () {
      return { lat: 20.1186645, lng: -98.7491321 }
    },
  },
  data() {
    return {
      mapKey: config[process.env.NODE_ENV].mapKey,
    }
  },
}
</script>
